import { render } from "./Range.vue?vue&type=template&id=9e5b9dce"
import script from "./Range.vue?vue&type=script&lang=ts"
export * from "./Range.vue?vue&type=script&lang=ts"
script.render = render

export default script